module.exports = __webpack_public_path__ + "media/images/application2/BookingsReserve__warning-3cfe2a7ece9b6a0bc9c7059e4a1a2170.svg";